import { Component, EventEmitter, Output, OnInit, Input } from "@angular/core";

@Component({
  selector: "login-form",
  templateUrl: "./login-form.component.html",
})
export class LoginFormComponent implements OnInit {
  @Input() errorNotExist: boolean;
  @Output() sendLoginData = new EventEmitter();

  showFieldsError: boolean = false;
  showSuccessMsg: boolean = false;

  constructor() {}

  ngOnInit() {}

  onSubmit(form) {
    let formIsValid = form.form.status === "VALID";

    if (formIsValid) {
      this.sendLoginData.emit({
        email: form.value.email,
      });
      this.showFieldsError = false;
      this.showSuccessMsg = true;
    } else {
      this.showFieldsError = true;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/components/login-form/login-form.component.ts